/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_renewal',
    modelClass: require('./model'),
    viewClass: require('./view'),
    isEnabled() {
        const {isMembershipRenewalAtFirstBooking, isMembershipDualPriceDisplay} = Odigeo.Membership;
        const isDynpack = Odigeo.Utils.isRequestApp('dp');
        const isRenewalEnabled = isMembershipDualPriceDisplay && isMembershipRenewalAtFirstBooking && !isDynpack;
        return isRenewalEnabled;
    },
    options: {
        'membership-renewal': {
            membershipDiscountFmtd: Odigeo.Membership.membershipDiscountFmtd,
            membershipSubscriptionPriceFmtd: Odigeo.Membership.membershipSubscriptionPriceFmtd,
        },
    },
    methods: {
        getRequestData: function() {
            return this.model.getRequestData();
        },
        init: function() {
            this.listenTo(this.view, 'updateProduct', this.updateProduct);
        },
        updateProduct: function(action) {
            this.model.updateProduct(action);
        },
        deactivateMembership: function() {
            this.model.deactivateMembership();
        },
        isRenewalAtFirstBooking() {
            this.model.isRenewalAtFirstBooking();
        },
    },
});
